import clsx from 'clsx';

import {Icon} from '../Icon/Icon';

import type {FontAwesomeIconProps} from '@fortawesome/react-fontawesome';

type ErrorScreenContainerProps = React.HTMLAttributes<HTMLDivElement>;
export const ErrorScreenContainer = (props: ErrorScreenContainerProps) => {
  return (
    <div
      {...props}
      className="mx-auto flex max-w-4xl flex-col items-center justify-center gap-8"
    />
  );
};

type ErrorScreenBodyProps = React.HTMLAttributes<HTMLDivElement>;
export const ErrorScreenBody = ({className, ...props}: ErrorScreenBodyProps) => {
  return <div {...props} className={clsx('text-center', className)} />;
};

type ErrorScreenIconProps = FontAwesomeIconProps;
export const ErrorScreenIcon = (props: ErrorScreenIconProps) => {
  const cn = clsx(['text-8xl', props.className]);

  return <Icon {...props} className={cn} />;
};
